import { render } from "./GoldDocumentDetailDialog.vue?vue&type=template&id=ac822a96&scoped=true"
import script from "./GoldDocumentDetailDialog.vue?vue&type=script&lang=js"
export * from "./GoldDocumentDetailDialog.vue?vue&type=script&lang=js"

import "./GoldDocumentDetailDialog.vue?vue&type=style&index=0&id=ac822a96&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac822a96"]])

export default __exports__